import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.css';

interface BreadcrumbItem {
	label: string;
	href?: string;
}

interface BreadcrumbProps {
	items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
	return (
		<nav aria-label="Breadcrumb">
			<ol className={styles.breadcrumb}>
				{items.map((item, index) => {
					const isLast = index === items.length - 1;
					// Use label as key — breadcrumb segments are unique path components
					const key = item.label || `bc-${index}`;
					return (
						<li key={key} style={{ display: 'contents' }}>
							{index > 0 && <span className={styles.separator}>/</span>}
							{item.href && !isLast ? (
								<Link to={item.href} className={styles.segment}>
									{item.label}
								</Link>
							) : (
								<span
									className={[styles.segment, isLast ? styles.segmentCurrent : '']
										.filter(Boolean)
										.join(' ')}
								>
									{item.label}
								</span>
							)}
						</li>
					);
				})}
			</ol>
		</nav>
	);
}
